import type { Components, Theme } from '@mui/material/styles';

export const MuiCard: Components<Theme>['MuiCard'] = {
  defaultProps: { elevation: 0 },
};
